<template>
  <Modal
    :header="header"
    class="calico-tiers-table-dialog"
    @close="$emit('close')"
  >
    <template #content>
      <div class="dialog-content">
        <div class="intro">
          <p class="heading--large">
            {{ dialogs.TIERS_TABLE_TITLE }}
          </p>
          <p class="body--medium">
            {{ body.before }}
            <span class="emph">{{ dialogs.TIERS_TABLE_RISK_LABEL }}</span>
            {{ body.between }}
            <span class="emph">{{ dialogs.TIERS_TABLE_DATA_CONFIDENCE_LABEL }}</span>
            {{ body.after }}
          </p>
        </div>
        <CalicoTiersTable />
      </div>
    </template>
    <template #footer>
      <button
        class="button-secondary"
        @click="$emit('close')"
      >
        Close
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/template/modal/index.vue'
import CalicoTiersTable from '@/components/calico/tiersTable/index.vue'
import { BetaScoreDialogs } from '@/enums'

export default {
  name: 'TiersTableDialog',
  components: { 
    Modal, 
    CalicoTiersTable 
  },
  computed: {
    header() { return BetaScoreDialogs.TIERS_TABLE_HEADER },
    dialogs() { return BetaScoreDialogs },
    body() {
      const t = BetaScoreDialogs.TIERS_TABLE_BODY_TEMPLATE
      const [before, rest] = t.split('{risk}')
      const [between, after] = rest.split('{confidence}')
      return { before, between, after }
    }
  }
}
</script>

<style lang="scss">
.calico-tiers-table-dialog {
  .dialog-content {
    @include inset-space($space-medium);
    color: $color-text-primary;
  }
  .intro {
    @include stack-space($space-xsmall);
    .emph { 
      font-weight: 700; 
      text-decoration: underline; 
    }
  }
  div.footer { @include inset-space($space-medium); }
}
</style>
